module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"expand_review":"もっと見る","collapse_review":"レビューを閉じる"}}')
  delete Component.options._Ctor
}
